import React from 'react'
import { cn } from 'ethcss'
import Button from 'blocks.simple/button/button'
import DisplaysMap from '../../__map/_displays/catalog__map_displays'
import ItemDisplays from '../../__item/_displays/catalog__item_displays'
import Icon from 'blocks.simple/icon/icon'
import { api } from 'core/api/ConnectionManager'
import { addListener } from 'core/helpers'
import styles from './catalog__template_displays.jcss'
import helpers from 'core/helpers'
import helpersDigitalSignages from 'core/helpers/_digitalSignages'
import translate from 'core/translate'
import { colors, getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { Status } from 'molecules/Status'
import { Marker } from 'atoms/Marker'
import { helpersMarker } from 'core/helpers/marker'
import { getParamsForMultipleMoveDisplays } from 'core/utils/displayUtil'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import store from 'core/store'
import { openApprove } from 'pages/displays/displays.state'
import { NoDevices } from './noDevices/NoDevices'
import { ItemData } from '../../../../core/models/Template'
import { appActions } from 'blocks.app/app/app.state'
import { CatalogMethods } from '../../catalog.local.methods'
import { CatalogItem } from '../../catalog.types'
import DotTooltip from 'blocks.simple/dotTooltip/dotTooltip'
import _item from 'blocks.simple/item/item.jcss'

const noBroadcastCover = helpersDigitalSignages.getNoBroadcastIconSrc()
let timer: ReturnType<typeof setTimeout> | null = null

interface AvailableParentGroup {
    id: number
    availableDestinationQ: boolean
}

interface CustomListViewResponse {
    fields: Array<{
        selected: boolean
        field: string
    }>
}

interface DisplayTag {
    label: string
    value: number
    name: string
    id: number
}

interface BreadcrumbItem {
    name: string
    id?: number
}

type CatalogEventCallback = (dataItem: CatalogItem) => void

const getGroupId = (instance: { parentId?: number; groupId?: number }) => {
    if (typeof instance.parentId !== 'undefined') {
        return instance.parentId
    }

    return instance.groupId
}

export default {
    useCustomScrollX: true,
    useScrollOnlyForPath: (path: string) => {
        return path.includes('#/displays')
    },
    folderName: 'parentId',
    getMethod: 'getDisplaysAndGroupsByParentId',
    getByFiltersMethod: 'getDisplaysAndGroupsByFilters',
    mediaCellClassName: styles.mediaCellClassName,
    customParams: {
        limit: 35,
        parentId: null,
    },
    getByFiltersParams: {
        limit: 35,
    },

    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noDevices'),
    emptyIcon: 'not_allow',
    customEmptyBlock: () => <NoDevices />,
    moveItem: (id: number, groupId: number) => {
        const moveSettings = store.getState().user.data?.settings.digitalSignage || {
            groupScheduleMode: 'askEveryTime',
            overwriteSettings: 'askEveryTime',
        }
        if (moveSettings?.groupScheduleMode === 'askEveryTime' && moveSettings?.overwriteSettings === 'askEveryTime') {
            store.dispatch(appActions.setMoveSettingsModal({ id, groupId, isOpen: true, isGroup: false }))
        } else if (moveSettings?.groupScheduleMode === 'askEveryTime') {
            store.dispatch(
                appActions.setMoveSettingsModal({
                    id,
                    groupId,
                    isOpen: true,
                    isGroup: false,
                    disableOverwriteSettings: true,
                })
            )
        } else if (moveSettings?.overwriteSettings === 'askEveryTime') {
            store.dispatch(
                appActions.setMoveSettingsModal({
                    id,
                    groupId,
                    isOpen: true,
                    isGroup: false,
                    disableGroupScheduleMode: true,
                })
            )
        } else {
            api.send('editDisplay', {
                id,
                groupId,
                groupScheduleMode: moveSettings?.groupScheduleMode,
                overwrightSettings: moveSettings?.overwriteSettings,
            })
        }
    },
    moveFolder: (id: number, parentId: number) => {
        const moveSettings = store.getState().user.data?.settings.digitalSignage
        if (moveSettings?.groupScheduleMode === 'askEveryTime' && moveSettings?.overwriteSettings === 'askEveryTime') {
            store.dispatch(appActions.setMoveSettingsModal({ id, parentId, isOpen: true, isGroup: true }))
        } else if (moveSettings?.groupScheduleMode === 'askEveryTime') {
            store.dispatch(
                appActions.setMoveSettingsModal({
                    id,
                    parentId,
                    isOpen: true,
                    isGroup: true,
                    disableOverwriteSettings: true,
                })
            )
        } else if (moveSettings?.overwriteSettings === 'askEveryTime') {
            store.dispatch(
                appActions.setMoveSettingsModal({
                    id,
                    parentId,
                    isOpen: true,
                    isGroup: true,
                    disableGroupScheduleMode: true,
                })
            )
        } else {
            api.send('editGroup', {
                id,
                parentId,
                groupScheduleMode: moveSettings?.groupScheduleMode,
                overwrightSettings: moveSettings?.overwriteSettings,
            })
        }
    },
    getDragData: (p_: { item: ItemData }) => {
        return JSON.stringify({ id: p_.item.id, type: p_.item.type })
    },
    multipleMove: (sourceId: number[], sourceFolderId: number[], parentId: number) => {
        return new Promise<unknown>((resolve, reject) => {
            const displays = {
                sourceId: sourceId.length ? sourceId : undefined,
                sourceFolderId: sourceFolderId.length ? sourceFolderId : undefined,
                parentId,
            }

            const params = {
                digitalSignageId: displays.sourceId,
                groupId: displays.sourceFolderId,
                nestedQ: false,
            }

            api.send<typeof params, AvailableParentGroup[]>('getAvailableParentGroups', params)
                .then((res) => {
                    const targetGroup = res.find((group: { id: number }) => group.id === parentId)
                    return !!targetGroup && targetGroup.availableDestinationQ
                })
                .then((isAvailableForMove: boolean) => {
                    if (isAvailableForMove) {
                        const params = getParamsForMultipleMoveDisplays(sourceId, sourceFolderId, displays.parentId)
                        api.send('moveDsAndGroups', params).then(resolve, reject)
                        return
                    }
                    reject()
                    store.dispatch(emitError('noAccessTransferToGroup'))
                })
        })
    },
    addItemButton: () => {
        if (!helpers.isAvailable({ key: 'digitalSignage', action: 'create' })) {
            return null
        }

        return (
            <Button rounded="full_md" mod="withShadow" onClick={() => store.dispatch(openApprove(''))}>
                {translate('add')}
            </Button>
        )
    },
    map: (p_: React.ComponentProps<typeof DisplaysMap>) => <DisplaysMap {...p_} />,
    settingsPrefixes: 'digitalSignage',
    // Активирует расширенный поиск
    allowAdvancedSearch: true,
    // showFilter: true,
    useNewFilter: true,
    tile: ItemDisplays,
    viewOptions: (pathname: string) => {
        if (pathname.includes('displays')) {
            return [
                {
                    id: 'tile',
                    name: translate('tile'),
                    icon: 'tile',
                    iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
                    iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
                },
                {
                    id: 'list',
                    name: translate('list'),
                    icon: 'list',
                    iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
                    iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
                },
                {
                    id: 'map',
                    name: translate('map'),
                    icon: 'location',
                    iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
                    iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
                },
            ]
        }

        return [
            {
                id: 'tile',
                name: translate('tile'),
                icon: 'tile',
                iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
                iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
            },
            {
                id: 'list',
                name: translate('list'),
                icon: 'list',
                iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
                iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
            },
        ]
    },
    sortOptions: () => [
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: 'name', name: translate('byNameAsc') },
        { id: '-name', name: translate('byNameDesc') },
        { id: 'status', name: translate('sortStatusOnline') },
        { id: '-status', name: translate('sortStatusOffline') },
        { id: 'type', name: translate('devices') },
        { id: '-type', name: translate('groups') },
    ],
    getItemModel: (dataItem: ItemData, getSelected: (item: ItemData) => boolean, deviceTileView: string) => {
        const item = { ...dataItem } as ItemData & {
            currentlyPlaying?: unknown[]
            downloadPercentage?: unknown[]
            hasBroadcast?: boolean
        }

        if (item.freeStorageSize) {
            item.freeStorageSize = (item.freeStorageSize / Math.pow(1024, 3)).toFixed(2) + ' GB'
        }
        if (item.usedStorageSize) {
            item.usedStorageSize = (item.usedStorageSize / Math.pow(1024, 3)).toFixed(2) + ' GB'
        }
        if (item.storageSize) {
            item.storageSize = (item.storageSize / Math.pow(1024, 3)).toFixed(2) + ' GB'
        }

        if (!item.cover) {
            item.cover = []
        }
        if (!item.currentlyPlaying) {
            item.currentlyPlaying = []
        }
        if (!item.downloadPercentage) {
            item.downloadPercentage = []
        }
        if (item.cover === 'ignore') {
            delete item.cover
        }

        if (item.type && deviceTileView !== 'simple') {
            item.cover = [...item.cover, ...[noBroadcastCover, noBroadcastCover, noBroadcastCover, noBroadcastCover]]
            item.cover = item.cover.slice(0, 4)
        }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }
        if (!item.type) {
            item.type = 'digitalSignage'
        }

        return item
    },
    getBackendModel: (item: ItemData) => {
        if (item.type !== 'group') {
            return api.send('getDisplay', { id: item.id }, { hideLoader: true })
        } else {
            return api.send('getGroup', { groupId: item.id }, { hideLoader: true })
        }
    },
    getItemClassName: (item: ItemData) => {
        if (item.type === 'digitalSignage') {
            return item.platformId === null
                ? `test-digitalSignage-virtual-${item.id}`
                : `test-digitalSignage-${item.id}`
        }
        if (item.type === 'group') {
            return 'digitalSignageGroup'
        }

        return ''
    },
    isEqual: helpersDigitalSignages.isEqual,
    onCreateListeners: [
        (cb: CatalogEventCallback, clearList: string[]) => api.addObserver('groupCreated', cb, clearList),
        (cb: CatalogEventCallback, clearList: string[]) => api.addObserver('displayCreated', cb, clearList),
    ],
    onUpdateListeners: [
        (cb: CatalogEventCallback, clearList: string[]) => api.addObserver('groupsUpdated', cb, clearList),
        (cb: CatalogEventCallback, clearList: string[]) => api.addObserver('groupUpdated', cb, clearList),
        (cb: CatalogEventCallback, clearList: string[]) => api.addObserver('displayUpdated', cb, clearList),
        addListener.updateDisplayProgress,
    ],
    onDeleteListeners: [
        (cb: CatalogEventCallback, clearList: string[]) =>
            api.addObserver('groupDeleted', ({ id }: { id: number }) => cb({ id, type: 'group' }), clearList),
        (cb: CatalogEventCallback, clearList: string[]) =>
            api.addObserver(
                'displayDeleted',
                ({ id }: { id: number }) => cb({ id, type: 'digitalSignage' }),
                clearList
            ),
    ],
    isFolder: (item: ItemData) => item.type === 'group',
    init(this: CatalogMethods, callback: () => void) {
        const p_ = this.props

        Promise.all([
            api.send<{ view: string }, CustomListViewResponse>('getCustomListView', { view: 'DigitalSignage' }),
            api.send<Record<string, never>, DisplayTag[]>('getDsTags', {}),
        ]).then((res) => {
            const fields: {
                id: number | string
                name: string
            }[] = []

            res[0].fields.forEach((item: { selected: boolean; field: string }) => {
                if (item.selected) {
                    fields.push({
                        id: item.field,
                        name: translate(item.field),
                    })
                }
            })

            const tags = res[1]
            tags.forEach((tag) => {
                tag.label = tag.name
                tag.value = tag.id
            })

            p_.onGetTags(tags)

            this.setState({ isInit: true, fields, tags }, callback)
        })

        api.addObserver(
            'digitalSignageScreenshotCreated',
            ({
                digitalSignageId,
                id,
                url,
                createdAt,
                groupId,
            }: {
                digitalSignageId: number
                id: number
                url: string
                createdAt: string
                groupId: number
            }) => {
                const s_ = this.state
                const { selectedInfo } = this.props

                const dataItem = { id: digitalSignageId, type: 'digitalSignage' }
                const screenshotData = { id, url, createdAt }

                s_.list.forEach((listItem: ItemData, index: number) => {
                    if (dataItem.id === listItem.id && dataItem.type === listItem.type) {
                        listItem.screenshots = [...(listItem.screenshots || []), screenshotData]
                    }
                })

                this.setState(s_)

                if (selectedInfo && selectedInfo.type === 'group' && selectedInfo.id === groupId) {
                    if (timer) {
                        clearTimeout(timer)
                    }
                    timer = setTimeout(() => {
                        api.send<{ groupId: number }, ItemData>('getGroup', { groupId: selectedInfo.id }).then(
                            (groupModel) => {
                                this.updateList([groupModel])
                            }
                        )
                    }, 600)
                }
            },
            this.clearListenersList
        )
    },
    unmount() {},
    getBreadcrumbs(this: CatalogMethods, groupId: number) {
        const breadcrumbs: BreadcrumbItem[] = [{ name: translate('devices'), id: undefined }]

        if (!groupId) {
            this.setState({ breadcrumbs })
            return
        }

        api.send<{ groupId: number }, BreadcrumbItem[]>('getGroupBreadcrumbs', { groupId }).then((data) => {
            data.reverse()
            this.setState({ breadcrumbs: [...breadcrumbs, ...data] })
        })
    },
    getFilterField(
        s_: { tags: { id: number; name: string }[] },
        filter: Record<string, Array<string | number>>,
        query: { [index: string]: string },
        field: { id: string }
    ) {
        filter[field.id] = query[field.id].split('//')

        if (field.id === 'tags') {
            filter[field.id].forEach((fieldItem, index: number) => {
                const currentTag: { id: number; name: string } | undefined = s_.tags.find(
                    (tag) => tag.name === fieldItem
                )

                if (currentTag) {
                    filter[field.id][index] = currentTag.id
                }
            })
        }
    },
    moveOnUpdate(
        this: CatalogMethods,
        {
            prev,
            next,
        }: {
            prev: { parentId?: number; groupId?: number }
            next: { parentId?: number; groupId?: number }
        }
    ) {
        const p_ = this.props

        if (p_.customOptions?.useScheduleCatalog) {
            return false
        }

        if (this.isMap(p_)) {
            return false
        }

        if (this.filter.hasActualSchedule) {
            return false
        }

        const prevId = getGroupId(prev)
        const nextId = getGroupId(next)

        return prevId !== nextId
    },
    list: {
        status: (p_: { type: string; descendantStatusCount: { status: string; count: number }[]; status: string }) => {
            if (p_.type === 'group' && p_.descendantStatusCount) {
                return (
                    <div className={styles.statusWrapper}>
                        {renderStatus(p_.descendantStatusCount, 'online')}
                        {renderStatus(p_.descendantStatusCount, 'offline')}
                        {renderStatus(p_.descendantStatusCount, 'error')}
                        {renderStatus(p_.descendantStatusCount, 'online_display_off')}
                        {renderStatus(p_.descendantStatusCount, 'sleep')}
                        {renderStatus(p_.descendantStatusCount, 'updating')}
                    </div>
                )
            }
            return translate(p_.status)
        },
        orientation: ({ orientation }: { orientation: number }) => {
            const displayOrientation = helpersDigitalSignages.getOrientation(orientation)

            if (!displayOrientation) {
                return null
            }

            return displayOrientation.name
        },
        identification: (item: { identificationTimeoutS: number }) => {
            return item.identificationTimeoutS ? (
                <Icon
                    type="identification"
                    size={18}
                    color={getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active}
                />
            ) : null
        },
        name: (
            { name, status, type, activeQ }: { name: string; status: string; type: string; activeQ?: boolean },
            active: boolean,
            p_: undefined,
            nested: number
        ) => {
            const color: { [index: string]: string } = {
                offline: 'offline',
                error: 'error',
                online: 'online',
                ping: 'ping',
            }
            const isLocked = type === 'digitalSignage' && activeQ === false

            return (
                <div
                    className={styles.name}
                    style={{
                        marginLeft: 40 * nested,
                    }}
                >
                    <div className={cn(styles.status, isLocked && styles.statusLocked)}>
                        <Icon type={type === 'group' ? 'files' : 'display'} size={20} color={color[status]} />
                        {isLocked && (
                            <div className={styles.lockBadge}>
                                <Icon type="lock" size={20} color={colors.warning} />
                            </div>
                        )}
                    </div>
                    <div>{name}</div>
                </div>
            )
        },
        createdAt: ({ createdAt }: { createdAt: string }) => helpers.getFormattedLocalDate(createdAt, 'DD/MM/YYYY'),
        lastConnection: ({ lastConnection }: { lastConnection: string }) =>
            helpers.getFormattedLocalDate(lastConnection, 'DD/MM/YYYY'),
        updatedAt: ({ updatedAt }: { updatedAt: string }) => helpers.getFormattedLocalDate(updatedAt, 'DD/MM/YYYY'),
        tags: ({ tags }: { tags: { name: string }[] }) => {
            if (tags) {
                return tags.map((tag) => tag.name).join(', ')
            } else {
                return null
            }
        },
        imei: ({ imei }: { imei: string }) => {
            if (Array.isArray(imei)) {
                return imei.join(', ')
            } else {
                return null
            }
        },
        description: ({ description }: { description: string }) => {
            return <div className={styles.description}>{description}</div>
        },
        address: ({ address }: { address: string }) => {
            if (!address) {
                return null
            }

            return (
                <div style={{ maxWidth: 500 }}>
                    <DotTooltip tooltip={{ html: address }}>
                        <div className={_item.ellipsis}>{address}</div>
                    </DotTooltip>
                </div>
            )
        },
        locked: (item: { activeQ: boolean; type: string }) => {
            return item.activeQ === false && item.type === 'digitalSignage' ? <>{translate('yes')}</> : null
        },
    },
}

const renderStatus = (
    descendantStatusCount: { status: string; count: number }[],
    status: 'offline' | 'online' | 'error' | 'updating' | 'sleep' | 'online_display_off'
) => {
    const statusInfo = descendantStatusCount.find((item) => item.status === status)

    return (
        <Status
            className={styles.listStatus}
            disable={statusInfo && statusInfo.count <= 0}
            status={status}
            isList={true}
        >
            {statusInfo && statusInfo.count}
        </Status>
    )
}
